import React from 'react';

import Icon, { GLYPHS } from '../../../common/icon';

const CheckboxSpinner = () => (
  <div className="c-checkbox--holder u-mr">
    <div className="c-handoff-bar__spinner">
      <Icon glyph={GLYPHS.spinner} className="o-icon--small" />
    </div>
  </div>
);

export default CheckboxSpinner;
